<template>
  <div id="extra-component-form-validation-demo">
    <List></List>
  </div>
</template>

<script>

import List from "./GeofenceList.vue"

export default {
  components: {
    List
  }
}
</script>
